module.exports = __webpack_public_path__ + "img/yz.5e460968.png";